import Component from "vue-class-component";
import Vue from "Vue";
import { Prop, Watch } from "vue-property-decorator";

@Component
export default class VerticalScroll extends Vue {
	public displayScrollbar = true;
	private sensibiliy = 0.3;
	private viewHeight;
	private fullHeight;
	private thumb;
	private track;

	@Prop({ default: true })
	public rounded;

	@Prop({ default: true })
	public padding;

	@Prop({ default: false })
	public alwaysVisible;

	@Prop({ default: false })
	public refreshEvent;

	@Prop({ default: 0 })
	public maxheight;

	public mounted(): void {
		this.init();
	}

	@Watch("refreshEvent")
	public refresh(): void {
		const topPosition = this.fullHeight.getBoundingClientRect().top;
		if (topPosition + this.fullHeight.offsetHeight > window.innerHeight) {
			this.fullHeight.style.height = window.innerHeight - topPosition - 15 + "px";
		} else {
			this.fullHeight.style.height = "";
		}

		this.viewHeight.scrollTo({
			top: 0
		});

		this.thumb.style.top = 0;

		this.setSizeScrollbar();
		this.listenScrollbar();
	}

	public init(): void {
		this.viewHeight = <HTMLDivElement>this.$refs.viewHeight;
		this.fullHeight = <HTMLDivElement>this.$refs.fullHeight;
		this.thumb = <HTMLDivElement>this.$refs.thumb;
		this.track = <HTMLDivElement>this.$refs.track;

		this.refresh();

		window.addEventListener("resize", () => {
			this.setSizeScrollbar();
		}, true);
	}

	private listenScrollbar(): void {
		let positionScroll = 0;
		let isDragging = false;
		this.viewHeight.scrollTo({
			top: 0,
			behavior: "smooth"
		});
		let beSmooth = true;

		this.viewHeight.addEventListener("wheel", (event) => {
			event.stopPropagation();
			event.preventDefault();

			beSmooth = (Math.abs(event.deltaY) >= 40);
			positionScroll = this.getPositionScrollbar(this.viewHeight, event.deltaY, positionScroll);
			this.viewHeight.scrollTo({
				top: positionScroll,
				behavior: beSmooth ? "smooth" : "instant"
			});

			this.thumb.style.top = positionScroll * 100 / this.fullHeight.scrollHeight + "%";
		});

		this.thumb.addEventListener("mousedown", (event) => {
			isDragging = true;
		});

		window.addEventListener("mousemove", (event) => {
			if (isDragging) {
				const containerRect = this.track.getBoundingClientRect();
				const mouseY = event.clientY - containerRect.top;
				const scrollRatio = mouseY / containerRect.height;
				const maxScrollTop = this.viewHeight.scrollHeight - this.viewHeight.offsetHeight;
				const newScrollTop = scrollRatio * maxScrollTop;

				// Vérification des limites de défilement
				positionScroll = Math.max(0, Math.min(newScrollTop, maxScrollTop));

				this.viewHeight.scrollTo({
					top: positionScroll,
					behavior: "instant"
				});

				this.thumb.style.top = (positionScroll * 100) / this.fullHeight.scrollHeight + "%";
			}
		});

		window.addEventListener("mouseup", () => {
			isDragging = false;
		});

		window.addEventListener("mouseleave", () => {
			isDragging = false;
		});

	}

	private getPositionScrollbar(el: any, deltaY: any, scrollTop: any): number {
		let positionScroll = scrollTop;
		positionScroll += (deltaY * this.sensibiliy);

		if (positionScroll < 0) {
			positionScroll = 0;
		}
		if (positionScroll > el.scrollHeight - el.offsetHeight) {
			positionScroll = el.scrollHeight - el.offsetHeight;
		}

		return positionScroll;
	}

	public setSizeScrollbar(): void {
		if (this.viewHeight.offsetHeight > 0 && this.fullHeight.scrollHeight > 0) {
			const viewableRatioHeight = this.viewHeight.offsetHeight / this.fullHeight.scrollHeight;

			if (viewableRatioHeight < 1) {
				this.thumb.style.height = (viewableRatioHeight >= 1) ? "100%" : this.viewHeight.offsetHeight * viewableRatioHeight + "px";
				this.thumb.style.top = 0 + "px";
				this.fullHeight.scrollTop = 0;
				this.displayScrollbar = true;
			} else {
				this.displayScrollbar = this.alwaysVisible ? true : false;
			}
		} else {
			this.displayScrollbar = this.alwaysVisible ? true : false;
		}
	}
}



// WEBPACK FOOTER //
// ./src/shared/components/VerticalScroll/vertical-scroll.ts